module.exports = __webpack_public_path__ + "static/media/up-button.e2b92e8a.svg";